import { getCommonConfig, updateCommonConfig } from "@/services/commonconfig";
import React, { useEffect, useState } from "react";


const SessionConfig: React.FC = () => {
  const [logout, setLogout] = useState(0);
  const [warning, setWarning] = useState(0);
  const [inactive, setInactive] = useState(0);

  const [initial, setInitial] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    const res = await getCommonConfig();
    setLogout(res.LogoutTime);
    setWarning(res.WarningTime);
    setInactive(res.InactiveDays);
    setInitial(JSON.stringify(res));
  };

  const hasChanges =
    initial !== "" &&
    JSON.stringify({
      LogoutTime: logout,
      WarningTime: warning,
      InactiveDays: inactive,
    }) !== initial;

  const handleSave = async () => {
    setSaving(true);

    await updateCommonConfig({
      LogoutTime: logout,
      WarningTime: warning,
      InactiveDays: inactive,
    });

    setInitial(JSON.stringify({
      LogoutTime: logout,
      WarningTime: warning,
      InactiveDays: inactive,
    }));

    setSaving(false);
  };

  const handleCancel = () => {
    const parsed = JSON.parse(initial);
    setLogout(parsed.LogoutTime);
    setWarning(parsed.WarningTime);
    setInactive(parsed.InactiveDays);
  };

  return (
    <div className="border border-gray-200 rounded-md bg-[#fbfaf7] p-3 space-y-3">

      <div className="grid grid-cols-3 gap-3">

        <div className="flex flex-col text-xs">
          <label className="mb-1 text-gray-600">Logout Time (mins)</label>
          <input
            type="number"
            className="border border-gray-300 px-2 py-1 rounded focus:ring-2 focus:ring-orange-400"
            value={logout}
            onChange={(e) => setLogout(Number(e.target.value))}
          />
        </div>

        <div className="flex flex-col text-xs">
          <label className="mb-1 text-gray-600">Warning Time (mins)</label>
          <input
            type="number"
            className="border border-gray-300 px-2 py-1 rounded focus:ring-2 focus:ring-orange-400"
            value={warning}
            onChange={(e) => setWarning(Number(e.target.value))}
          />
        </div>

      </div>

      <div className="flex justify-end gap-2 items-center">

        {hasChanges && (
          <div className="text-orange-600 border border-orange-300 bg-orange-50 px-2 py-0.5 rounded text-xs">
            Unsaved
          </div>
        )}

        <button
          className="bg-[#e7e5e0] px-3 py-1 rounded text-xs"
          onClick={handleCancel}
          disabled={!hasChanges}
        >
          Cancel
        </button>

        <button
          className="bg-orange-500 text-white px-3 py-1 rounded text-xs"
          onClick={handleSave}
          disabled={!hasChanges || saving}
        >
          Save
        </button>

      </div>

    </div>
  );
};

export default SessionConfig;